"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTopUpMinValue = exports.updateTopUpDefaultnValue = exports.setCurrentScreen = exports.resetErrors = exports.openTopup = exports.getBundleDetailsSuccess = exports.getBundleDetailsRequest = exports.getBundleDetailsFailure = exports.getBalanceDetailsRequest = exports.buyAddonSuccess = exports.buyAddonRequest = exports.buyAddonFailure = exports.SET_CURRENT_SCREEN = exports.RESET_ERRORS = exports.GET_BUNDLE_DETAILS_SUCCESS = exports.GET_BUNDLE_DETAILS_REQUEST = exports.GET_BUNDLE_DETAILS_FAILURE = exports.GET_BALANCE_DETAILS_SUCCESS = exports.GET_BALANCE_DETAILS_REQUEST = exports.GET_BALANCE_DETAILS_FAILURE = exports.BUY_ADDON_SUCCESS = exports.BUY_ADDON_REQUEST = exports.BUY_ADDON_FAILURE = void 0;
var _appConstants = require("../appConstants");
// Buy addon actions
var BUY_ADDON_REQUEST = "@".concat(_appConstants.pkgName, "/BUY_ADDON_REQUEST");
exports.BUY_ADDON_REQUEST = BUY_ADDON_REQUEST;
var BUY_ADDON_SUCCESS = "@".concat(_appConstants.pkgName, "/BUY_ADDON_SUCCESS");
exports.BUY_ADDON_SUCCESS = BUY_ADDON_SUCCESS;
var BUY_ADDON_FAILURE = "@".concat(_appConstants.pkgName, "/BUY_ADDON_FAILURE");
exports.BUY_ADDON_FAILURE = BUY_ADDON_FAILURE;
var SET_CURRENT_SCREEN = "@".concat(_appConstants.pkgName, "/SET_CURRENT_SCREEN");
exports.SET_CURRENT_SCREEN = SET_CURRENT_SCREEN;
var buyAddonRequest = function buyAddonRequest(payload, genericActionsWidget, productOrderEndPoint, purchaseFlowErrorHandling) {
  return {
    type: BUY_ADDON_REQUEST,
    payload: payload,
    genericActionsWidget: genericActionsWidget,
    productOrderEndPoint: productOrderEndPoint,
    purchaseFlowErrorHandling: purchaseFlowErrorHandling
  };
};
exports.buyAddonRequest = buyAddonRequest;
var buyAddonSuccess = function buyAddonSuccess() {
  return {
    type: BUY_ADDON_SUCCESS
  };
};
exports.buyAddonSuccess = buyAddonSuccess;
var buyAddonFailure = function buyAddonFailure(error) {
  return {
    type: BUY_ADDON_FAILURE,
    payload: error
  };
};
exports.buyAddonFailure = buyAddonFailure;
var setCurrentScreen = function setCurrentScreen(currentScreen) {
  return {
    type: SET_CURRENT_SCREEN,
    payload: currentScreen
  };
};

// addon details actions
exports.setCurrentScreen = setCurrentScreen;
var GET_BUNDLE_DETAILS_REQUEST = "@".concat(_appConstants.pkgName, "/GET_BUNDLE_DETAILS_REQUEST");
exports.GET_BUNDLE_DETAILS_REQUEST = GET_BUNDLE_DETAILS_REQUEST;
var GET_BUNDLE_DETAILS_SUCCESS = "@".concat(_appConstants.pkgName, "/GET_BUNDLE_DETAILS_SUCCESS");
exports.GET_BUNDLE_DETAILS_SUCCESS = GET_BUNDLE_DETAILS_SUCCESS;
var GET_BUNDLE_DETAILS_FAILURE = "@".concat(_appConstants.pkgName, "/GET_BUNDLE_DETAILS_FAILURE");
exports.GET_BUNDLE_DETAILS_FAILURE = GET_BUNDLE_DETAILS_FAILURE;
var RESET_ERRORS = "@".concat(_appConstants.pkgName, "/RESET_ERRORS");
exports.RESET_ERRORS = RESET_ERRORS;
var getBundleDetailsRequest = function getBundleDetailsRequest(payload) {
  return {
    type: GET_BUNDLE_DETAILS_REQUEST,
    payload: payload
  };
};
exports.getBundleDetailsRequest = getBundleDetailsRequest;
var getBundleDetailsSuccess = function getBundleDetailsSuccess(payload) {
  return {
    type: GET_BUNDLE_DETAILS_SUCCESS,
    payload: payload
  };
};
exports.getBundleDetailsSuccess = getBundleDetailsSuccess;
var getBundleDetailsFailure = function getBundleDetailsFailure(payload) {
  return {
    type: GET_BUNDLE_DETAILS_FAILURE,
    payload: payload
  };
};
exports.getBundleDetailsFailure = getBundleDetailsFailure;
var resetErrors = function resetErrors() {
  return {
    type: RESET_ERRORS
  };
};

// Other widgets actions
exports.resetErrors = resetErrors;
var GET_BALANCE_DETAILS_REQUEST = function GET_BALANCE_DETAILS_REQUEST(genericActionsWidget) {
  return "@".concat(genericActionsWidget, "/GET_BALANCE_DETAILS_REQUEST");
};
exports.GET_BALANCE_DETAILS_REQUEST = GET_BALANCE_DETAILS_REQUEST;
var GET_BALANCE_DETAILS_SUCCESS = function GET_BALANCE_DETAILS_SUCCESS(genericActionsWidget) {
  return "@".concat(genericActionsWidget, "/GET_BALANCE_DETAILS_SUCCESS");
};
exports.GET_BALANCE_DETAILS_SUCCESS = GET_BALANCE_DETAILS_SUCCESS;
var GET_BALANCE_DETAILS_FAILURE = function GET_BALANCE_DETAILS_FAILURE(genericActionsWidget) {
  return "@".concat(genericActionsWidget, "/GET_BALANCE_DETAILS_FAILURE");
};
exports.GET_BALANCE_DETAILS_FAILURE = GET_BALANCE_DETAILS_FAILURE;
var openTopup = function openTopup(topUpWidget) {
  return {
    type: "@".concat(topUpWidget, "/OPEN_TOPUP")
  };
};
exports.openTopup = openTopup;
var updateTopUpMinValue = function updateTopUpMinValue(topUpWidget, payload) {
  return {
    type: "@".concat(topUpWidget, "/UPDATE_TOP_UP_MIN_VALUE"),
    payload: payload
  };
};
exports.updateTopUpMinValue = updateTopUpMinValue;
var updateTopUpDefaultnValue = function updateTopUpDefaultnValue(topUpWidget, payload) {
  return {
    type: "@".concat(topUpWidget, "/UPDATE_TOP_UP_DEFAULT_VALUE"),
    payload: payload
  };
};
exports.updateTopUpDefaultnValue = updateTopUpDefaultnValue;
var getBalanceDetailsRequest = function getBalanceDetailsRequest(genericActionsWidget) {
  return {
    type: GET_BALANCE_DETAILS_REQUEST(genericActionsWidget)
  };
};
exports.getBalanceDetailsRequest = getBalanceDetailsRequest;